var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.localNavigation.length > 0
    ? _c(
        "ul",
        {
          staticClass: "navigation-list",
          class: {
            legacy: _vm.navType === "legacy",
            storefront: _vm.navType === "storefront"
          },
          style: _vm.listStyle
        },
        _vm._l(_vm.localNavigation, function(secondaryNav) {
          return _c(
            "li",
            {
              key: secondaryNav.href,
              class:
                _vm.navType === "storefront" ? "tertiary-nav" : "secondary-nav"
            },
            [
              _c("span", [
                !_vm.hideSeeAll
                  ? _c("a", { attrs: { href: secondaryNav.href } }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(secondaryNav.title || secondaryNav.name) +
                          "\n      "
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(secondaryNav.title || secondaryNav.name) +
                          "\n      "
                      )
                    ])
              ]),
              _vm._v(" "),
              secondaryNav.subnav
                ? _c(
                    "ul",
                    [
                      _vm._l(secondaryNav.subnav, function(tertiaryNav) {
                        return _c(
                          "li",
                          {
                            key: tertiaryNav.href,
                            staticClass: "tertiary-nav"
                          },
                          [
                            _c("a", { attrs: { href: tertiaryNav.href } }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    tertiaryNav.title || tertiaryNav.name
                                  ) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.navType !== "legacy" && !_vm.hideSeeAll
                        ? _c("li", { staticClass: "tertiary-nav" }, [
                            _c("a", { attrs: { href: secondaryNav.href } }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.getAllCategoryText(secondaryNav)) +
                                  "\n        "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }